import { useState } from "react";

export function useMaximize(defaultMax = false) {
    const [maximized, setMaximized] = useState(defaultMax);
    const toggle = () => setMaximized((v) => !v);
    const overlayClass = `report-overlay${maximized ? " maximized" : ""}`;
    const panelClass = `report-panel${maximized ? " maximized" : ""}`;
    const icon = maximized ? "⊡" : "⊞";
    return { maximized, toggle, overlayClass, panelClass, icon };
}